import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import SrLink from 'client/components/SrLink/SrLink';
import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import Navbar from 'client/components/Navbar';
import ButtonDeprecated, {
  BUTTON_THEME_BLUE,
} from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

import {
  SR_API_ACTION_DRIVERS_CREATE_ACCOUNT,
} from 'api/actionTypes';
import { SCREEN_ID_DRIVER_CREATE_ACCOUNT } from 'client/constants/screenIds';

import postWithState from 'client/actions/postWithState';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withApiState from 'client/helpers/withApiState';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';
import branch from 'client/core/branch';
import MarketActions from 'client/actions/Market';

function getFormFields({ marketsById }) {
  const marketChoices = Object.keys(marketsById).reduce((memo, marketId) => [
    ...memo,
    {
      id: marketId,
      label: marketsById[marketId].displayName,
      value: marketId,

    },
  ], []);

  const formFields = [
    {
      id: 'name',
      title: 'name',
      type: 'short_text',
      properties: {
        placeholder: 'Driver Name',
      },
      validations: ['required'],
    },
    {
      id: 'email',
      title: 'email',
      type: 'email',
      validations: ['required', 'email'],
      properties: {
        placeholder: 'Driver Email...',
      },
    },
    {
      id: 'phone',
      title: 'phone',
      type: 'phone',
      validations: ['required', 'phone'],
      properties: {
        placeholder: 'Driver Phone Number...',
      },
    },
    {
      id: 'password',
      title: 'password',
      type: 'password',
      validations: ['required', 'password'],
    },
    {
      id: 'address',
      title: 'address',
      type: 'short_text',
      validations: ['required'],
      properties: {
        placeholder: 'Driver Address...',
      },
    },
    {
      id: 'marketId',
      title: 'Market',
      type: 'select',
      properties: {
        choices: marketChoices,
        multipleSelection: false,
        allowEmptyArray: true,
      },
      validations: [],
    },
  ];
  return formFields;
}

@withTransitionHook
@withScrollToTop
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withApiState({
  driverCreateAccountApiState: {
    action: SR_API_ACTION_DRIVERS_CREATE_ACCOUNT,
  },
})
@branch({
  marketsById: ['markets', 'byId'],
})
@withScreenId(SCREEN_ID_DRIVER_CREATE_ACCOUNT)
class DriverCreatePage extends Component {
  static propTypes = {
    marketsById: PropTypes.object.isRequired,
  };

  static fetchData(match, inject) {
    return Promise.all([
      MarketActions.getList(inject),
    ]);
  }

  static getPageMetadata = () => ({
    pageTitle: 'Admin Create Driver User | Sunroom Rentals',
    section: 'Admin',
  });

  _onSubmit = (values) => {
    const { dispatch, history } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_DRIVERS_CREATE_ACCOUNT,
      payload: {
        name: values.name,
        email: values.email,
        phone: `${values.phone}`,
        marketId: parseInt(values.marketId, 10),
        password: values.password,
        address: values.address,
      },
    });
    history.push('/admin');
  }

  render() {
    const {
      marketsById,
      driverCreateAccountApiState,
    } = this.props;

    const formFields = getFormFields({ marketsById });

    return (
      <div className='page-admin'>
        <div className='adminContainer'>
          <Navbar
            redirectLogoTo='/admin'
            leftButton={(
              <SrLink
                scrollToLastPosition
                redirectToLastLocation
                className='back link'
                to='/admin'
              />
            )}
          />
          <div className='section'>
            <Formik
              initialValues={createInitialValues({ formFields })}
              validate={createFormValidationFn(formFields)}
              onSubmit={this._onSubmit}
              render={(formikBag) => (
                <Form>
                  {formFields.map((formField) => (
                    <SrFormikField
                      key={formField.id}
                      formikBag={formikBag}
                      formField={formField}
                    />
                  ))}
                  <ButtonDeprecated
                    theme={BUTTON_THEME_BLUE}
                    type='button'
                    onClick={formikBag.handleSubmit}
                    disabled={driverCreateAccountApiState.inProgress}
                  >
                    {driverCreateAccountApiState.inProgress ? 'Loading...' : 'Submit'}
                  </ButtonDeprecated>
                </Form>
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

DriverCreatePage.displayName = 'DriverCreatePage';

export default DriverCreatePage;
